const data =[
    {
        "id": "521ed0b9-c3a4-4619-9b80-bfc5dcd6787a",
        "collection": "dezinfekce.potrubi",
        "data": {
            "title": "Dezinfekce potrubí vnitřních vodovodů a řadů, protokol o dezinfekci potrubí",
            "subtitle": "Provádím dezinfekci a proplach vnitřních vodovodů, rozvodů vody a vodovodních řadů.",
            "warning": "Dezinfekce vnitřního vodovodu pro vodu určenou k lidské spotřebě se provádí dle ČSN EN 806 1 - 5 a ČSN 75 5409"
        },
        "date": "2021-12-04T16:03:14+00:00"
    },
    {
        "id": "53325295-3749-4b63-878f-b4ce98cd58f3",
        "collection": "dezinfekce.potrubi",
        "data": {
            "items": [
                {
                    "heading": "Komplexní služba",
                    "text": "<p><strong>Dezinfekce potrubí vnitřního vodovodu, rozbor vody a vystavení \"Protokolu o dezinfekci a proplachu potrubí\".</strong><p/><p>Provedení dezinfekce a proplachu <a href='#dezinfekce-proplach' class='text-info'>vodovodních řadů</a> a přípojek včetně vystavení \"Protokolu o dezinfekci a proplachu potrubí\".</p><p>Zajištění rozboru vody z vydezinfikovaných rozvodů vody dle <a href='https://con1.artatolstatic.com/file/820a3cc7-f2a7-4766-8c6f-80b488f3f6f7.pdf' target='_blank' class='text-info'>vyhlášky 252 / 2004 sb.</a> laboratoří akreditovanou ČIA.</p><p>Dezinfekce vodovodů pitné i TUV, šoková dezinfekce rozvodů teplé vody zasažených <a href='https://con1.artatolstatic.com/file/e30b1752-d47c-4a7e-84e6-2d7e9d0cba65.pdf' target='_blank' class='text-info'>bakterií Legionella Pneumophila</a>.</p><strong>Dezinfekci potrubí provádím po celé České republice.</strong>"
                },
                {
                    "heading": "Průběh dezinfekce",
                    "text": "<p>K hotovému vnitřnímu vodovodu který je po tlakové zkoušce již osazen zařizovacími předměty a napuštěn vodou je připojeno zařízení <a href='#rems-multi-push' class='text-info'>Rems Multi-Push</a>, nebo <a href='#deplach-14' class='text-info'>dávkovací čerpadlo</a> DEPLACH, které postupně načerpá do potrubí dezinfekční činidlo.</p><p>Následuje doba zdržení, kdy dochází k vlastní dezinfekci potrubí. Po jejím uplynutí je dezinfekční činidlo z rozvodů vody postupně vypuštěno s využitím <a href='#dechlorace-vody' class='text-info'>neutralizačního zásobníku</a>. <strong>(Při použití bezchlorového dezinfekčního činidla se neutralizace neprovádí)</strong>. Poté je potrubí opět propláchnuto pitnou vodou.</p><p class='alert-primary px-3 py-2'>Dezinfekce vnitřního vodovodu pro vodu určenou k lidské spotřebě se provádí dle ČSN EN 806 1 - 5 a ČSN 75 5409.</p>"
                },
                {
                    "heading": "Dezinfekční činidla",
                    "text": "<p><strong>Varianta 1)</strong><br/>Bezchlorové dezinfekční činidlo. Účinná látka je na bázi peroxidu vodíku a koloidního stříbra.</p><p><strong>Varianta 2)</strong><br/>Chlorové dezinfekční činidlo. Účinná látka je aktivní chlor.</p><strong>Činidla jsou schválena rozhodnutím Hlavního hygienika České republiky.</strong>"
                },
                {
                    "heading": "Dezinfekční technika",
                    "text": "Pro dezinfekci vnitřních rozvodů je použito zařízení <a href='#rems-multi-push' class='text-info'>REMS Multi-Push</a>. Potrubí je čištěno a dezinfikováno směsí vzduchu, vody a dezinfekčního činidla. V případě že toto zařízení není možmo připojit k rozvodu vody je pro dezinfekci potrubí použito <a href='#deplach-14' class='text-info'>dávkovací čerpadlo DEPLACH 14</a>."
                },
                {
                    "heading": "Co je nutno udělat pro připojení dezinfekčního zařízení k rozvodu vody",
                    "text": "<strong>Varianta 1)</strong><p>Pro připojení zařízení <a href='#rems-multi-push' class='text-info'>Rems Multi-Push</a> je nutno za vodoměrem nebo před dezinfikovaným úsekem namontovat <a href='#vodoinstalaterske-prace' class='text-info'>dva kulové ventily se závitem 1\"</a>, tak aby bylo možno připojit hadice kterými bude voda skrz zařízení a dál do rozvodů vody protékat.</p><strong>Varianta 2)</strong><p>Pro připojení <a href='#deplach-14' class='text-info'>dezinfekčního dávkovacího čerpadla DEPLACH</a> k rozvodu vody je nutno namontovat za vodoměr nebo před dezinfikovaný úsek potrubí <a href='#vodoinstalaterske-prace' class='text-info'>kulový ventil</a> s vnějším závitem 3/4\" nebo 1\".</p><p>Pokud na hlavním přívodu žádný takový ventil není, je provedení dezinfekce značně problematické.</p>"
                },
                {
                    "heading": "Kolaudace",
                    "text": "<strong>Protokol o dezinfekci potrubí a protokol o mikrobiální a chemické nezávadnosti vody dle vyhlášky č.252/2004 sb. jsou důležité podklady k úspěšné kolaudaci.</strong>"
                }
            ]
        },
        "date": "2022-01-03T15:19:16+00:00"
    },
    {
        "id": "498658b1-5934-43ac-a2b9-30125f51842c",
        "collection": "dezinfekce.potrubi",
        "data": {
            "items": [
                {
                    "id": "terminy",
                    "heading": "Volné termíny",
                    "text": "<p><strong>Pro aktuální informace o volném termínu pro provedení dezinfekce potrubí prosím volejte tel : 603 91 82 13</strong></p><p>Volné termíny pro dezinfekci potrubí platí pro celou Českou republiku.</p><p>Před objednáním dezinfekce potrubí se prosím ujistěte zda je možno připojit dávkovací čerpadlo k rozvodu vody v objektu. Bez vstupního ventilu (běžně kulový ventil s vnějším závitem 1\" nebo 3/4\") umístěného těsně za vodoměrem nebo před dezinfikovaným úsekem nelze potrubí vydezinfikovat. <a href='#vodoinstalaterske-prace' class='text-info'>Sanitační ventil - klikněte zde</a></p><p>Dezinfekci vnitřních rozvodů vody a vodovodních řadů provádím i v objektech a na místech kde není k dispozici přípojka elektrické energie. O nutnosti použití elektrocentrály mě prosím informujte již při objednávce.</p>"
                },
                {
                    "id": "dezinfekce-vodovodu",
                    "heading": "Dezinfekce vodovodu",
                    "text": "<p>Provádím dezinfekci vodovodů v nových a rekonstruovaných objektech.</p><p>Provádím dezinfekce a proplach vodovodních řadů před připojením k vodovodní síti.</p><p>Provádím dezinfekci a proplach vodovodů i ve starších objektech kde dlouhodobě nebyl žádný nebo byl jen minimální odběr pitné vody.</p><p><strong>Provádím dezinfekci a proplach potrubí ve školách, školkách atd. kde po prázdninové odstávce pitné vody nevyhověl rozbor</strong> vyhlášce 252/2004, tyto dezinfekce provádím zejména v odpoledních a nočních hodinách.</p>"
                },
                {
                    "id": "cena",
                    "heading": "Cena",
                    "text": "<p>Předběžnou cenu za provedení dezinfekce a proplachu potrubí se dozvíte při konzultaci na kontaktech - tel : 603 91 82 13, <a href='mailto:dezinfekce@dezinfekcepotrubi.cz'>dezinfekce@dezinfekcepotrubi.cz</a></p><p>Dezinfekce a proplach potrubí vnitřního vodovodu zahrnuje: dezinfekční a neutralizační činidla, dopravu, práci, protokol o dezinfekci a proplachu potrubí, odběr a dopravu vzorku certifikovaným vzorkařem, protokol o mikrobiologické a chemické nezávadnosti dle vyhlášky č. 252/2004 z laboratoře akreditované ČIA.</p><p>Platba fakturou.</p><p><strong>Pokud po dezinfekci potrubí využijete samoodběr vzorku nemusí být uznána platnost protokolu o mikrobilologické a chemické nezávadnosti z důvodu necertifikovaného odběru!</strong></p>"
                },
                {
                    "id": "vysledky-rozboru-vody",
                    "heading": "Výsledky rozborů vody",
                    "text": "<p>Jak vypadá rozbor vody z nového nevydezinfikovaného potrubí? <a class='text-info' href='https://con1.artatolstatic.com/file/08b6d6a5-abf7-42c3-abce-d6179a877ef5.pdf' target='_blank'>Dva příklady jsou zde</a></p><p>Jak se do nového rozvodu vody dostanou koliformní bakterie? Velmi jednoduše. Například vododovodní přípojka do objektu je připojována ve výkopu se stojatou dešťovou vodou a několik ml. této vody se samozřejmě při napojování dostane do potrubí a následně rozvodů vody v objektu.</p><p>Kde dochází k mikrobiálnímu znečištění ve starých rozvodech vody? Staré slepé rozvody vody kde voda dlouhodobě neprotéká a jen \"stojí v trubkách\", velmi dobře přežívají nevhodné bakterie i v nečištěných perlátorech. Samostatnou kapitolou je připojování různých pítek a fontánek k rozvodům vody průhlednými hadičkami kde má i řasa vhodné podmínky pro svůj růst.</p><p>Příklad rozboru z vodovodu který má <a class='text-info' href='https://con1.artatolstatic.com/image/1800/a01408b9-91a3-4844-a24d-226f4f122270.jpg' target='_blank'>slepá ramena najdete zde</a></p><p>Jak vypadají výsledky rozborů vody z vodovodu který kontaminuje záplavová voda? <a class='text-info' href='https://con1.artatolstatic.com/image/1800/41f939ac-8cbc-4e3b-bc9c-8bd50790248b.jpg' target='_blank'>Rozbor vody z vnitřního vodovodu kontaminovaného povodňovou vodou po proplachu pitnou vodou</a><a class='text-info' href='https://con1.artatolstatic.com/image/1800/0b9b385f-b9ec-42f0-8a7f-13d610750603.jpg' target='_blank'>Stejný vodovod po provedení dezinfekcei a proplachu potrubí vnitřního vodovodu</a></p>"
                }
            ]
        },
        "date": "2022-01-03T17:19:54+00:00"
    },
    {
        "id": "9a401ed7-52ff-4c02-9a8b-2139e9753c1a",
        "collection": "dezinfekce.potrubi",
        "data": {
            "blocks": [
                {
                    "id": "rems-multi-push",
                    "left": true,
                    "img": "https://con1.artatolstatic.com/image/1800/8a4251fa-1918-41b9-bde2-080a966e0f51.jpg",
                    "title": "REMS Multi-Push",
                    "subtitle": "Dezinfekce vnitřních rozvodů",
                    "desc": "Výkonná, kompaktní, elektronická proplachovací jednotka a jednotka pro zkoušení tlaku s bezolejovým kompresorem. K proplachování vodou nebo směsí vody a vzduchu, dezinfikování, čištění, konzervování systémů potrubních vedení, k provádění tlakových zkoušek systémů potrubních vedení a nádob stlačeným vzduchem"
                },
                {
                    "id": "deplach-14",
                    "left": false,
                    "img": "https://con1.artatolstatic.com/image/1800/d60943d7-df9c-498f-b256-c7663112ff5b.jpg",
                    "title": "Dávkovací čerpadlo DEPLACH 14",
                    "subtitle": "Dezinfekce vnitřního vodovodu v bytovém domě",
                    "desc": "Dezinfekce vodovodního potrubí v bytovém domě, připojení za vodoměrem a zpětnou klapkou."
                },
                {
                    "id": "dezinfekce-proplach",
                    "left": true,
                    "img": "https://con1.artatolstatic.com/image/1800/656015e3-f3a5-4cae-9c72-0c8b9946a42e.jpg",
                    "title": "Dezinfekce a proplach vodovodních řadů",
                    "subtitle": "Zajištění akreditovaných odběrů a rozborů vody z dezinfikovaného řadu.",
                    "desc": "Pokud není v místě dezinfekce vodovodního řadu přípojka elektrického energie 230V pro připojení dávkovacích čerpadel ,informujte mě o nutnosti využití elektrocentály již při objednávce dezinfekce potrubí vodovodního řadu."
                },
                {
                    "id": "vodoinstalaterske-prace",
                    "left": false,
                    "img": "https://con1.artatolstatic.com/image/1800/cbc7fd16-911b-4b7b-8346-50504096fc79.jpg",
                    "title": "Vodoinstalatérské práce",
                    "subtitle": "Sanitační kulový ventil pro dezinfekci potrubí",
                    "desc": "V případě že v rozvodu vody není nainstalován kulový sanitační ventil pro napojení dávkovacího čerpadla (běžně s vnějším závitem 3/4\" nebo 1\") je provedení dezinfekce vodovodu značně problematické a v některých případech i nemožné. <strong>Skrze roháčky, vodovodní baterie a protizámrazové ventily dávkovat dezinfekční činidlo do potrubí nelze!</strong>"
                },
                {
                    "id": "dechlorace-vody",
                    "left": true,
                    "img": "https://con1.artatolstatic.com/image/1800/0e246943-b1b0-4e33-91eb-cf625f758c95.png",
                    "title": "Dechlorace vody",
                    "subtitle": "Dechlorace vody po dezinfekci potrubí",
                    "desc": "Chlorovaná voda z rozvodů vody není po dezinfekci vypuštěna přímo do kanalizace,ale je postupně dechloračním činidlem neutralizována ve speciálním zásobníku. Po zneutralizování je voda ze zásobníku vypuštěna do kanalizace (voda splňuje parametry pitné vody)."
                }
            ]
        },
        "date": "2022-01-03T14:39:03+00:00"
    },
    {
        "id": "a5552c2a-4745-4ed1-9739-c0bca6a5e6aa",
        "collection": "dezinfekce.potrubi",
        "data": {
            "references": [
                {
                    "href": "https://www.caravanmetropol.cz/",
                    "name": "Caravan Metropol - Hala Klíčany"
                },
                {
                    "href": "https://skolalipa.cz/",
                    "name": "Střední zdravotnická škola - Česká Lípa"
                },
                {
                    "href": "http://www.domovslunecnidvur.cz/index.php",
                    "name": "Domov Sluneční dvůr p.o. - Jestřebí"
                },
                {
                    "href": "https://www.lidl.cz/",
                    "name": "Lidl - Štětí"
                },
                {
                    "href": "https://www.fruitisimo.cz/",
                    "name": "Fruitisimo - OC Bořislavka"
                },
                {
                    "href": "https://ms.hostivice.cz/",
                    "name": "Mateřská školka Hostivice"
                },
                {
                    "href": "https://zdibskypivovar.cz/",
                    "name": "Zdibský pivovar - Zdiby"
                },
                {
                    "href": "https://www.lidl.cz/",
                    "name": "Lidl - Roudnice nad Labem"
                },
                {
                    "href": "https://www.benzina.cz/",
                    "name": "ČS&nbsp; Benzina - Česká Kamenice"
                },
                {
                    "href": "https://www.lidl.cz/?gclsrc=aw.ds",
                    "name": "Lidl - Velká Chuchle"
                },
                {
                    "href": "https://www.kamennyujezd.cz/",
                    "name": "OÚ Kamenný Újezd u Rokycan"
                },
                {
                    "href": "https://www.unibar.cz/",
                    "name": "UCB Technometal, Chrustenice"
                },
                {
                    "href": "https://www.acr.army.cz/strukt/gen-stab/posadkove-velitelstvi-praha-5603",
                    "name": " Posádkové velitelství Praha "
                },
                {
                    "href": "https://www.lidl.cz/",
                    "name": "Lidl - Písecká, Chomutov"
                },
                {
                    "href": "https://www.terezia.eu/",
                    "name": "Terzia Company s.r.o. - Brandýs n. Labem"
                },
                {
                    "href": "https://www.ahv.cz/",
                    "name": "AHV ekologický servis s.r.o., Stránčice"
                },
                {
                    "href": "https://www.garrettmotion.com/",
                    "name": "Garrett Motion Czech Republic, Brno"
                },
                {
                    "href": "https://stores.primark.com/cs/cesko/praha/vaclavske-namesti-47",
                    "name": "Primark Praha"
                },
                {
                    "href": "https://www.nemocnice-melnik.cz/",
                    "name": "Nemocnice s poliklinikou Mělník"
                },
                {
                    "href": "https://reality.skanska.cz/prodej-bytu-praha-8/port-karolina-4",
                    "name": "Port Karolína C, Praha - Karlín"
                },
                {
                    "href": "https://www.bbcentrum.cz/cz/k-pronajmu/budova-b",
                    "name": "BB Centrum, B - Praha 4 - Michle"
                },
                {
                    "href": "https://www.lidl.cz/",
                    "name": "Lidl - Benešov"
                },
                {
                    "href": "https://reality.skanska.cz/prodej-bytu-praha-8/port-karolina-2",
                    "name": "Port Karolína B , Praha - Karlín"
                },
                {
                    "href": "https://reality.skanska.cz/prodej-bytu-praha-9/ctvrt-emila-kolbena-1",
                    "name": "Čtvrť Emila Kolbena 1 -&nbsp; i -Top s.r.o"
                },
                {
                    "href": "https://www.rpgrecycling.cz/",
                    "name": "RPG Recycling s.r.o. - Uherský Brod"
                },
                {
                    "href": "http://plomahodonin.cz/",
                    "name": "areál Ploma Hodonín - INSBERG sro"
                },
                {
                    "href": "https://www.plazza.cz/cs/o-projektu",
                    "name": "Lidl - Plazza Střížkov"
                },
                {
                    "href": "https://www.libeznice.cz/zpravy/nova-skola-se-pekne-zakulacuje",
                    "name": "Nová ZŠ Líbeznice"
                },
                {
                    "href": "http://www.subterra.cz/mainpage.tab.cs.aspx",
                    "name": "Subterra a.s."
                },
                {
                    "href": "https://www.policie.cz/clanek/odbor-sluzby-dopravni-policie-669494.aspx",
                    "name": "PČR - kuchyň, Kongresová 2"
                },
                {
                    "href": "http://www.novaskolapsary.cz/",
                    "name": "ZŠ Psáry a Dolní Jirčany - INSBERG sro"
                },
                {
                    "href": "https://www.bydleninakrejcarku.cz/",
                    "name": "Bydlení Na Krejcárku "
                },
                {
                    "href": "https://www.subterra.cz/mainpage.tab.cs.aspx",
                    "name": "Subterra a.s"
                },
                {
                    "href": "https://www.norma-online.de/cz/angebote/",
                    "name": "NORMA&nbsp;&nbsp; Jílové u Prahy&nbsp; - Tover s.r.o"
                },
                {
                    "href": "https://www.kosteleckeuzeniny.cz/",
                    "name": "Kostelecké uzeniny"
                },
                {
                    "href": "https://www.kok.cz/",
                    "name": "K.O.K. Tábor s.r.o."
                },
                {
                    "href": "https://www.bowlbar.cz/",
                    "name": "BOWL BAR&nbsp; Praha"
                },
                {
                    "href": "https://search.google.com/local/posts?q=Radek+Str%C3%A1nsk%C3%BD+-+dezinfekce+potrub%C3%AD&amp;ludocid=6870058479554655166#lkt=LocalPoiPosts&amp;lpstate=pid:664548937415731499&amp;trex=m_t:lcl_akp,rc_f:nav,rc_ludocids:6870058479554655166",
                    "name": "2 MŠ Hostivice"
                },
                {
                    "href": "http://www.shaft.cz/#home",
                    "name": "SHAFT s.r.o"
                },
                {
                    "href": "http://vaecontrols.cz/cs/uvod",
                    "name": "VAE Controls"
                },
                {
                    "href": "https://valeo.cz/cs/valeo-rakovnik/",
                    "name": "Valeo Rakovník"
                },
                {
                    "href": "http://www.prazskacokolada.cz",
                    "name": "Pražská čokoláda s.r.o. "
                },
                {
                    "href": "http://www.nexentireczech.cz/",
                    "name": "Nexen Tire Europe"
                },
                {
                    "href": "http://www.samsungengineering.com/",
                    "name": "Samsung Engineering "
                },
                {
                    "href": "http://www.acis-complex.com/en/index.html",
                    "name": "Acis Complex Kft."
                },
                {
                    "href": "https://www.p3parks.com/",
                    "name": "P3 Logistic Parks, D2 - Horní Počernice"
                },
                {
                    "href": "http://www.professionals.cz/cs/nemovitosti/europort-airport-center-156049/",
                    "name": "Europort Airport Center"
                },
                {
                    "href": "http://optimalfacility.eu/cz/",
                    "name": "OPTIMAL"
                },
                {
                    "href": "https://www.geaviation.cz/",
                    "name": "GE Aviation Czech"
                },
                {
                    "href": "http://www.tescocr.cz/cs",
                    "name": "TESCO Czech"
                },
                {
                    "href": "http://www.atalian.cz/",
                    "name": "Atalian"
                },
                {
                    "href": "http://www.grandberoun.cz/cz/",
                    "name": "Hotel Grand Litava Beroun"
                },
                {
                    "href": "http://www.intechnology.cz/",
                    "name": "INT s.r.o - DEK Hradec Králové"
                },
                {
                    "href": "http://www.policie.cz/default.aspx",
                    "name": "PČR Bartolomějská 4"
                },
                {
                    "href": "http://www.pekarnazelenalouka.cz/index.html",
                    "name": "Pekárna Zelená louka"
                },
                {
                    "href": "http://ifirmy.cz/firma/182065-martin-smida-insberg",
                    "name": "Insberg&nbsp; M. Šmída"
                },
                {
                    "href": "https://www.synthesia.eu/cze",
                    "name": "Synthesia a.s."
                },
                {
                    "href": "http://www.fluidengineering.cz/",
                    "name": "FLUID ENGINEERING a.s"
                }
            ]
        },
        "date": "2022-01-03T19:08:26+00:00"
    }
]
export default data